import React, { useEffect, useState } from "react";
import analyticsService from "../services/analytics.service";
import authsService from "../services/auths.service";

const Dashboard = () => {
  const userinfo = authsService.userinfo();
  const [clientoverviewarr, setClientoverviewarr] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filter, setFilter] = useState("");
  const [filterclient, setFilterclient] = useState("");
  //use effects
  useEffect(() => {
    getallClientoverview();
  }, []);

  //get allclient
  const getallClientoverview = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      filterclient: "",
      filtermonth: "",
      filteryear: "",
      search: "",
      between: "",
      sort: "",
      group: "client_id",
    };
    return await analyticsService
      .clientAirconoverview(data)
      .then((res) => {
        console.log(res.data);

        if (res.data.result) {
          setClientoverviewarr(res.data.result.data);
        } else {
          setClientoverviewarr([]);
        }
      })
      .catch((err) => {
        setClientoverviewarr([]);
      });
  };
  const selectrandomcolor = () => {
    const colors = [
      "#5EE5FA",
      "#5EC4FA",
      "#5E9EFA",
      "#5E73FA",
      "#5EF1FA",
      "#5EFAE0",
      "#605EFA",
    ];

    const random = Math.floor(Math.random() * colors.length);
    return random, colors[random];
  };
  return (
    <div>
      <div className="d-flex  ">
        <h1 className="flex-fill">Overview</h1><div>{/* <button
              onClick={() => {
                navigate("/clientevent");
              }}
              type="submit"
              className="btn btn-primary"
            >
              <i className="fa fa-plus"></i> Add Client
            </button> */}</div>
      </div>
      <div className="row">
        {clientoverviewarr.map((data, index) => (
          <div key={index} className="col-md-6 ">
            <div
              className="rounded bg-white shadow-sm mb-2"
            /*  style={{
              background: selectrandomcolor(data.client_fullname),
            }} */
            >
              <div className="d-flex p-2 ">
                <div className=" rounded p-3 bg-light ps-4 pe-4">
                  <div style={{ fontSize: 20 }} className="text-center fw-bold">
                    {data.client_total_aircon_unit}
                  </div>
                  <div>
                    <small>AirconUnit</small>{" "}
                  </div>
                </div>
                <div className="ps-2 ">
                  <div className="fw-bold fs-large text-capitalize">{data.client_fullname}</div>{" "}
                  <div className="">
                    Location - {data.client_total_aircon}
                  </div>
                  <div className="">
                    Case - {data.client_total_service}
                  </div>
                  <div className="">
                    Expense - ${data.client_total_amount}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
